import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Tag } from '../../../core/models/tag.model';
import { ChipComponent } from '../chip/chip.component';

/**
 * Renders a tag as a coloured chip. Tag labels are user-entered org
 * configuration, not translated content (design doc §7) — rendered verbatim.
 */
@Component({
  selector: 'app-tag-chip',
  standalone: true,
  imports: [ChipComponent],
  templateUrl: './tag-chip.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './tag-chip.component.css',
})
export class TagChipComponent {
  tag = input.required<Tag>();
}
